const mapStops = (stop) => {
  return {
    stop_type: stop.stop_type,
    shipment_ids: stop.shipment_ids,
  };
};

const _getRequest = (stops = []) => stops.map(mapStops);

export { _getRequest };
